import {
  CalendarIcon,
  EyeIcon,
  ListIcon,
  PencilSimpleIcon,
  ShoppingBagIcon,
  SparkleIcon,
  SquaresFourIcon,
  TagIcon,
} from '@phosphor-icons/react';

export const NAVIGATION_APPLICATIONS = [
  {
    application: 'TagLab',
    icon: <SquaresFourIcon size={20} color="#ffffff" />,
    features: [
      {
        title: 'Products',
        link: '/products',
        icon: <ShoppingBagIcon size={18} color="#ffffff" />,
      },
      {
        title: 'Tagging Jobs',
        link: '/tagging-jobs',
        icon: <TagIcon size={18} color="#ffffff" />,
      },
    ],
  },
  {
    application: 'Styling Guide',
    icon: <SparkleIcon size={20} color="#ffffff" />,
    features: [
      {
        title: 'Prompt Templates',
        link: '/prompt-templates',
        icon: <PencilSimpleIcon size={18} color="#ffffff" />,
      },
      {
        title: 'Occasions',
        link: '/occasions',
        icon: <CalendarIcon size={18} color="#ffffff" />,
      },
      // {
      //   title: 'Product Images',
      //   link: '/product-images',
      //   icon: <ProductIcon stroke="#ffffff" />,
      // },
      {
        title: 'Styling Jobs',
        link: '/styling-jobs',
        icon: <ListIcon size={18} color="#ffffff" />,
      },
      {
        title: 'Occasion Styling Jobs',
        link: '/styling-jobs-occasion',
        icon: <CalendarIcon size={18} color="#ffffff" />,
      },
      {
        title: 'Look Groups',
        link: '/look-groups',
        icon: <EyeIcon size={18} color="#ffffff" />,
      },
    ],
  },
] as const;
